import { render, staticRenderFns } from "./VerifyWorkEmail.vue?vue&type=template&id=4cf07623"
import script from "./VerifyWorkEmail.vue?vue&type=script&lang=js"
export * from "./VerifyWorkEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports